module.exports = __webpack_public_path__ + "img/ballgas.67abec88.png";